/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/destructuring-assignment */
import React, { InputHTMLAttributes, useEffect, useRef, useState } from 'react';
import { icons } from '~/assets';
import Bullet from '../bullet';
import ContainerFlex from '../containerFlex';
// import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import * as Masks from '~/utils/masks';
import * as St from './styles';

export enum MaskTypes {
  CPF = 'cpfMask',
  CEP = 'cepMask',
  DATE = 'dateMask',
  HOUR_MIN_SEC = 'hourMinSecMask',
  HOUR_MIN = 'hourMinMask',
  PHONE = 'phoneMask',
  CREDIT_CARD = 'creditCardMask',
  NUMERIC = 'numericMask',
  CURRENCY = 'currencyMask',
  EMAIL = 'emailMask',
  CPF_CNPJ = 'cpfCnpjMask',
  CPF_CNPJ_EXTENDED = 'cpfCnpjExtendedMask',
  CNPJ = 'cnpjMask',
}

export type InputProps = {
  bulletColor?: string;
  name?: string;
  id?: string;
  label?: string;
  labelFor?: string;
  icon?: any;
  initialValue?: string;
  disabled?: boolean;
  errorMessage?: string;
  error?: string;
  errorDiv?: boolean;
  edit?: boolean;
  mask?: MaskTypes;
  value?: string | number;
  placeholder?: string;
  blind?: boolean;
  defaultValue?: string | number;
  onChange?: (e: any) => void;
} & InputHTMLAttributes<HTMLInputElement>;

const Input = ({
  label,
  labelFor = '',
  name,
  placeholder,
  disabled = false,
  errorDiv = false,
  value,
  errorMessage,
  onChange = (e) => null,
  edit,
  mask,
  blind,
  bulletColor = null,
  defaultValue,
  icon,
  onFocus,
  onBlur,
  ...props
}: InputProps): JSX.Element => {
  const [isFocused, setIsFocused] = useState(false);
  const [isBlinded, setIsBlinded] = useState(true);
  const NewIcon = icon;

  const inputRef = useRef<HTMLInputElement>(null);
  const cursorPosRef = useRef<number | null>(null);

  useEffect(() => {
    if (cursorPosRef.current !== null && inputRef.current) {
      const pos = cursorPosRef.current;
      requestAnimationFrame(() => {
        if (inputRef.current) {
          inputRef.current.setSelectionRange(pos, pos);
        }
      });
      cursorPosRef.current = null;
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value: rawValue, name: inputName, selectionStart } = e.target;
    if (mask && rawValue !== '') {
      const previousValue = String(value ?? '');
      const valueMasked = Masks[mask](rawValue as never);

      const maskedStr = typeof valueMasked === 'string' ? valueMasked : valueMasked.masked;

      let newCursorPos: number;

      if (mask === MaskTypes.PHONE) {
        newCursorPos =
          (selectionStart ?? rawValue.length) + (maskedStr.length - rawValue.length);
      } else {
        const prevMaskChars = (previousValue.substring(0, selectionStart ?? 0).match(/\D/g) || []).length;
        const newMaskChars = (maskedStr.substring(0, (selectionStart ?? 0) + 1).match(/\D/g) || []).length;
        const offset = newMaskChars - prevMaskChars;

        newCursorPos = (selectionStart ?? maskedStr.length) + offset;
      }

      newCursorPos = Math.max(0, Math.min(newCursorPos, maskedStr.length));
      cursorPosRef.current = newCursorPos;

      return onChange({
        target: {
          value: valueMasked,
          name: inputName,
        },
      });
    }

    return onChange(e);
  };

  if (bulletColor) {
    return (
      <ContainerFlex row center>
        <St.Container isFocused={isFocused} error={errorDiv || !!errorMessage}>
          {!!label && <label htmlFor={labelFor}>{label}</label>}

          <ContainerFlex width={100} row space>
            <input
              ref={inputRef}
              type="text"
              onChange={handleChange}
              onFocus={(e) => {
                setIsFocused(true);
                onFocus?.(e);
              }}
              onBlur={(e) => {
                setIsFocused(false);
                onBlur?.(e);
              }}
              disabled={disabled}
              value={value}
              name={name}
              placeholder={placeholder}
              defaultValue={defaultValue}
              {...props}
            />
            {edit && <St.IconRight src={icons.inputEdit} />}
          </ContainerFlex>

          {errorMessage && <St.ErrorMessage>{errorMessage}</St.ErrorMessage>}
        </St.Container>

        {bulletColor && <Bullet size={16} color={bulletColor} margin={8} />}
      </ContainerFlex>
    );
  }

  return (
    <St.Container isFocused={isFocused} error={errorDiv || !!errorMessage}>
      {!!label && <label htmlFor={labelFor}>{label}</label>}

      <ContainerFlex width={100} row space>
        <input
          ref={inputRef}
          type={blind && isBlinded ? 'password' : 'text'}
          onChange={handleChange}
          onFocus={(e) => {
            setIsFocused(true);
            onFocus?.(e);
          }}
          onBlur={(e) => {
            setIsFocused(false);
            onBlur?.(e);
          }}
          disabled={disabled}
          value={value}
          name={name}
          placeholder={placeholder}
          {...props}
        />
        {edit && <St.IconRight src={icons.inputEdit} />}
        {blind && (
          <St.IconRight
            id="eye"
            src={isBlinded ? icons.noBlind : icons.blind}
            onClick={() => setIsBlinded((prev) => !prev)}
          />
        )}
        {icon ? (
          <ContainerFlex row center>
            <NewIcon />
          </ContainerFlex>
        ) : null}
      </ContainerFlex>

      {errorMessage && <St.ErrorMessage>{errorMessage}</St.ErrorMessage>}
    </St.Container>
  );
};

export default Input;
